<template>
  <footer class="hide-for-print footer h-[120px] w-full bottom-0">
    <div class="footer-content container">
        <div class="footer-menu w-1/2">
          <nav class="text-left mb-5 text-base">
            <ul aria-orientation="vertical">
              <li ><router-link to="/about" class="mg-2" :aria-current="$route.path === '/about' ? 'page' : undefined">About community legal centres</router-link></li>
              <li ><router-link to="/privacy" class="mg-2" :aria-current="$route.path === '/privacy' ? 'page' : undefined">Terms of use and privacy</router-link></li>
              <li ><router-link to="/services" class="mg-2" :aria-current="$route.path === '/services' ? 'page' : undefined">View all Services</router-link></li>
              <li ><router-link to="/service-search" class="mg-2" :aria-current="$route.path === '/service-search' ? 'page' : undefined">Search for a Service</router-link></li>
              <li ><a href="https://www.legalaid.nsw.gov.au/" class="mg-2" target="_blank" rel="noopener noreferrer" aria-label="Contact Law Access NSW (opens in a new tab)">Contact Law Access NSW</a></li>
            </ul>
          </nav>
          <!-- <a href="#/">Home</a> |
          <a href="#/services">See all services</a> |
          <a href="#/search">Search for help</a> |
          <a href="#/non-existent-path">Bad link test</a> -->
        </div>
        <div class="footer-right w-1/2 text-right float-left">
          <img src="@/assets/icons/CLCNSW-logo-white-blue-small.png" alt="CLCNSW Logo"  class="float-right"/>
        </div>
    </div>
  </footer>
</template>

<script>


export default {
  name: 'FooterArea',
  components: {

  },
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
img {
  width: auto;
  height: 100px;
}
h3 {
  /* margin: 40px 0 0; */
}
ul {
  list-style-type: none;
  /* padding: 0; */
}
li {
  /* display: inline-block; */
  /* margin: 0 10px; */
}
a {
  color: #057FA7;
}
.footer {
    /* height: 200px; */
    /* width: 100%; */
    background-color: white;

}
.footer-content {
    /* max-width: 1000px; */
    margin: auto;
    text-align: right;
    padding: 15px;
    color: #057FA7;
}
.footer-menu {
    float:left;
    color: #057FA7;
}
.footer-menu a {
    color: #003a78;
    font-family: 'Source Sans Pro', Arial, Helvetica, sans-serif;
/*     font-size: 25pt; */

}
.footer-menu a:hover {
    color: #057FA7;
}

</style>
